import * as React from 'react';
import {Option} from "ts-option";
import IndividualContact from "../../../model/contact/IndividualContact";
import {connect} from "react-redux";
import {RootState} from "../../../store/reducer/root/RootState";
import {getAddress, isSiteLoading} from "../../../store/view/site";
import {getIndividualContact} from "../../../store/view/contact";
import Address from "../../../model/address/Address";
import DeleteInputAddon from "../../ui/input/DeleteInputAddon";
import {ClickableProps} from "../../common/props/ClickableProps";
import TextArea from "../../../hiberUiKit/src/atoms/TextArea/TextArea";

interface ComponentProps {
	/**
	 * Contact id and type.
	 */
	contactId: string
	/**
	 * Callback on reset.
	 */
	onReset: () => void;
}

interface ReduxProps {
	/**
	 * Address to display.
	 */
	address: Option<Address>;
	/**
	 * Contact data to display.
	 */
	contactData: Option<IndividualContact>;
	/**
	 * Indicates if address data is loading.
	 */
	loading: boolean;
}

type Props = ComponentProps & ReduxProps & ClickableProps;

class ContactSelectorPresenter extends React.PureComponent<Props, {}> {
	render() {
		const text = this.props.contactData.map(cd => `${cd.data.displayName()}`).getOrElse("");
		return (
			<DeleteInputAddon addonPosition={"right"} onDeleteClick={this.props.onReset} onClick={this.props.onClick}>
				<TextArea onChange={() => {}}
						  value={text}
						  autoSize={true}
						  hasBorder={true}
						  rows={this.props.address.isDefined ? null : this.props.loading ? null : 1}/>
			</DeleteInputAddon>
		);
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	const contact = getIndividualContact(props.contactId, state);

	return {
		contactData: contact,
		address: contact.flatMap(c => c.data.primarySiteId.flatMap(siteId => getAddress(siteId, state))),
		loading: isSiteLoading(state)
	}
}

export default connect(mapStateToProps)(ContactSelectorPresenter)